import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import s from './Checkbox.css';

const propTypes = {
    onChange: PropTypes.func,
    className: PropTypes.string,
    checked: PropTypes.bool.isRequired,
    design: PropTypes.oneOf(['default', 'warning']),
    label: PropTypes.string,
    labelOnLeft: PropTypes.bool,
    readOnly: PropTypes.bool,
};

export class Checkbox extends React.Component {
    static defaultProps = {
        onChange: undefined,
        className: undefined,
        checked: false,
        design: 'default',
        label: '',
        labelOnLeft: false,
        readOnly: false,
    };

    render() {
        return (
            <button
                onClick={this.handleChange}
                className={classNames(
                    s.checkbox,
                    {
                        [s.red]: this.props.design === 'warning',
                        [s.checked]: this.props.checked,
                        [s.readonly]: this.props.readOnly,
                    },
                    this.props.className
                )}
            >
                {this.props.label && this.props.labelOnLeft && <p>{this.props.label || ''}</p>}

                <span />

                {this.props.label && !this.props.labelOnLeft && <p>{this.props.label || ''}</p>}
            </button>
        );
    }

    handleChange = e => {
        if (this.props.readOnly === false && this.props.onChange) {
            this.props.onChange(!this.props.checked);
        }
    };
}

Checkbox.propTypes = propTypes;



// WEBPACK FOOTER //
// ./app/web/src/components/fields/Checkbox.jsx